import { useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Calendar, Filter, ArrowRight, Camera, GraduationCap, Zap, Star, Eye, Heart } from "lucide-react";

const CATEGORIES = [
  { id: "all", label: "Tutti (48)", color: "#D4AF37" },
  { id: "deducibile", label: "Deducibile 100%", color: "#4285F4", count: 8 },
  { id: "start", label: "Pacchetto Start €99", color: "#EA4335", count: 8 },
  { id: "plus", label: "Pacchetto Plus €299", color: "#FBBC05", count: 8 },
  { id: "rooftop", label: "Pacchetto Rooftop €599", color: "#34A853", count: 8 },
  { id: "vt", label: "Virtual Tour 360°", color: "#D4AF37", count: 8 },
  { id: "cares", label: '</s.com/cares> #its4kids-Digitale', color: "#9C27B0", count: 8 },
];

const POSTS = [
  { n: 1, cat: "deducibile", title: "Sapevi che la formazione digitale è deducibile al 100%?", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 2, cat: "start", title: "Pacchetto START — La tua scheda Google, finalmente in ordine", sub: "Pacchetto Start €99" },
  { n: 3, cat: "plus", title: "Scheda Google sospesa? Il Pacchetto PLUS la riporta in vita", sub: "Pacchetto Plus €299" },
  { n: 4, cat: "rooftop", title: "ROOFTOP — Tutto incluso, zero pensieri per 12 mesi", sub: "Pacchetto Rooftop €599" },
  { n: 5, cat: "vt", title: "Il tuo negozio su Google Maps — come se ci fossi dentro", sub: "Virtual Tour 360°" },
  { n: 6, cat: "cares", title: "</s.com/cares> — Istruzione digitale per le nuove generazioni", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 7, cat: "deducibile", title: "Problema: 'Costa troppo'. Soluzione: 3 rate a TAEG 0%", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 8, cat: "start", title: "La tua scheda Google dice orari sbagliati? Ecco perché perdi clienti", sub: "Pacchetto Start €99" },
  { n: 9, cat: "plus", title: "'Questa scheda è stata sospesa' — Le 3 cause più comuni", sub: "Pacchetto Plus €299" },
  { n: 10, cat: "rooftop", title: "Un cliente ha scritto: 'Con Rooftop ho recuperato l'investimento in 2 mesi'", sub: "Pacchetto Rooftop €599" },
  { n: 11, cat: "vt", title: "La differenza tra una foto e un Virtual Tour? 300% di engagement in più", sub: "Virtual Tour 360°" },
  { n: 12, cat: "cares", title: "A scuola di Google Maps — il primo laboratorio #its4kids-Digitale", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 13, cat: "deducibile", title: "Lo sapevi? Il 43% delle P.IVA non sa che la formazione è deducibile", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 14, cat: "start", title: "Hai appena aperto? Le 5 cose da fare SUBITO sulla tua scheda Google", sub: "Pacchetto Start €99" },
  { n: 15, cat: "plus", title: "Recensione negativa? Ecco come rispondere (e trasformarla in opportunità)", sub: "Pacchetto Plus €299" },
  { n: 16, cat: "rooftop", title: "Rooftop vs fare da soli: i numeri dopo 6 mesi", sub: "Pacchetto Rooftop €599" },
  { n: 17, cat: "vt", title: "Timewarp: il tuo locale visto dall'alto come non l'hai mai visto", sub: "Virtual Tour 360°" },
  { n: 18, cat: "cares", title: "I ragazzi di Colle Val d'Elsa hanno mappato 12 negozi in un pomeriggio", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 19, cat: "deducibile", title: "Ultimo mese per dedurre la formazione 2025. Poi si riparte da zero", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 20, cat: "start", title: "3 errori che il 90% delle attività fa sulla scheda Google (e come correggerli in 1 ora)", sub: "Pacchetto Start €99" },
  { n: 21, cat: "plus", title: "ATTENZIONE: se vedi 'Aggiornamento suggerito' sulla tua scheda, agisci subito", sub: "Pacchetto Plus €299" },
  { n: 22, cat: "rooftop", title: "Rooftop: 3 posti rimasti per questo trimestre (zona Siena/Valdelsa)", sub: "Pacchetto Rooftop €599" },
  { n: 23, cat: "vt", title: "Google premia chi ha il Virtual Tour: ecco i dati ufficiali", sub: "Virtual Tour 360°" },
  { n: 24, cat: "cares", title: "Da settembre: laboratori #its4kids-Digitale in 4 scuole della Valdelsa", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 25, cat: "deducibile", title: "Federica, commercialista: 'Ho consigliato la deducibilità a 8 clienti'", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 26, cat: "start", title: "Luca ha verificato la scheda del bar dei genitori. Ci sono voluti 45 minuti", sub: "Pacchetto Start €99" },
  { n: 27, cat: "plus", title: "Hotel a Monteriggioni: scheda sospesa per 3 mesi. Recuperata in 5 giorni", sub: "Pacchetto Plus €299" },
  { n: 28, cat: "rooftop", title: "Ristorante in Valdelsa: da 0 a 2.800 views/mese con Rooftop", sub: "Pacchetto Rooftop €599" },
  { n: 29, cat: "vt", title: "50+ recensioni a 5 stelle: ecco cosa dicono i miei clienti sui tour", sub: "Virtual Tour 360°" },
  { n: 30, cat: "cares", title: "I ragazzi di San Gimignano hanno creato la mappa digitale del centro storico", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 31, cat: "deducibile", title: "FAQ: 'Ma PayPal Paga in 3 Rate come funziona esattamente?'", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 32, cat: "start", title: "FAQ: 'Posso verificare la scheda da solo?' Sì, ma...", sub: "Pacchetto Start €99" },
  { n: 33, cat: "plus", title: "FAQ: 'La scheda è sospesa da mesi. È troppo tardi?'", sub: "Pacchetto Plus €299" },
  { n: 34, cat: "rooftop", title: "FAQ: 'Perché Rooftop e non fare Start + Plus separati?'", sub: "Pacchetto Rooftop €599" },
  { n: 35, cat: "vt", title: "FAQ: 'Il Virtual Tour funziona anche per attività piccole?'", sub: "Virtual Tour 360°" },
  { n: 36, cat: "cares", title: "FAQ: 'Come posso portare #its4kids-Digitale nella mia scuola?'", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 37, cat: "deducibile", title: "Settembre: il mese perfetto per investire in formazione (e dedurla)", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 38, cat: "start", title: "Rientro dalle ferie: la tua scheda Google dice ancora 'orario estivo'?", sub: "Pacchetto Start €99" },
  { n: 39, cat: "plus", title: "Natale si avvicina: la tua scheda è pronta per il boom di ricerche?", sub: "Pacchetto Plus €299" },
  { n: 40, cat: "rooftop", title: "Regalo di Natale per la tua attività: Rooftop con Timewarp IN REGALO", sub: "Pacchetto Rooftop €599" },
  { n: 41, cat: "vt", title: "Inverno: quando i clienti non possono visitarti, il Virtual Tour lavora per te", sub: "Virtual Tour 360°" },
  { n: 42, cat: "cares", title: "Bilancio 2025 di </s.com/cares>: 6 scuole, 120 studenti, 80 negozi mappati", sub: "</s.com/cares> #its4kids-Digitale" },
  { n: 43, cat: "deducibile", title: "2026: la formazione digitale sarà ancora più importante (e ancora deducibile)", sub: "Deducibile 100% · TAEG 0% · PayPal 3 rate" },
  { n: 44, cat: "start", title: "Anno nuovo, scheda nuova: il primo check-up dell'anno è nel Pacchetto START", sub: "Pacchetto Start €99" },
  { n: 45, cat: "plus", title: "Nuova policy Google 2026: cosa cambia per le schede sospese", sub: "Pacchetto Plus €299" },
  { n: 46, cat: "rooftop", title: "Obiettivo 2026: 100 clienti Rooftop nella Valdelsa", sub: "Pacchetto Rooftop €599" },
  { n: 47, cat: "vt", title: "Il futuro del Virtual Tour: AI, realtà aumentata e Google Immersive View", sub: "Virtual Tour 360°" },
  { n: 48, cat: "cares", title: "Grazie. Un anno di </s.com/cares> — e il 2026 sarà ancora più grande", sub: "</s.com/cares> #its4kids-Digitale" },
];

const CAT_ICONS = {
  deducibile: GraduationCap,
  start: Zap,
  plus: Star,
  rooftop: Camera,
  vt: Eye,
  cares: Heart,
};

export default function SocialPlan() {
  const [filter, setFilter] = useState("all");

  const filtered = useMemo(() => 
    filter === "all" ? POSTS : POSTS.filter(p => p.cat === filter),
  [filter]);

  const getColor = (cat) => CATEGORIES.find(c => c.id === cat)?.color || "#D4AF37";

  return (
    <div className="min-h-screen bg-[#0c1220] text-white" style={{ fontFamily: "Poppins, sans-serif" }}>
      {/* Header */}
      <header className="border-b border-white/10 px-6 py-8">
        <div className="max-w-5xl mx-auto text-center">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Calendar className="w-6 h-6 text-[#D4AF37]" />
            <span className="text-[#D4AF37] font-black text-sm tracking-wider">PIANO EDITORIALE</span>
          </div>
          <h1 className="text-3xl sm:text-4xl font-black text-white mb-2">
            Google Business Profile — <span className="text-[#D4AF37]">48 Post</span>
          </h1>
          <div className="flex items-center justify-center gap-6 text-[#9CA3AF] text-sm mt-4">
            <span><strong className="text-white">6</strong> argomenti <strong className="text-white">x 8</strong> cicli</span>
            <span className="text-white/20">|</span>
            <span><strong className="text-white">1</strong> post / settimana</span>
            <span className="text-white/20">|</span>
            <span><strong className="text-white">48</strong> settimane / anno</span>
          </div>
        </div>
      </header>

      {/* Filter Tabs */}
      <nav className="border-b border-white/10 px-6 sticky top-0 bg-[#0c1220]/95 backdrop-blur-xl z-50">
        <div className="max-w-5xl mx-auto flex gap-1.5 overflow-x-auto py-3 scrollbar-hide">
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              onClick={() => setFilter(cat.id)}
              className={`px-4 py-2 rounded-full text-xs font-bold whitespace-nowrap transition-all flex items-center gap-1.5 ${filter === cat.id ? "text-black" : "text-[#9CA3AF] hover:text-white bg-white/5 hover:bg-white/10"}`}
              style={filter === cat.id ? { backgroundColor: cat.color } : {}}
              data-testid={`filter-${cat.id}`}
            >
              <Filter className="w-3 h-3" />
              {cat.label}
            </button>
          ))}
        </div>
      </nav>

      {/* Posts Grid */}
      <main className="max-w-5xl mx-auto px-6 py-10">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <AnimatePresence mode="popLayout">
            {filtered.map((post) => {
              const Icon = CAT_ICONS[post.cat] || Zap;
              const color = getColor(post.cat);
              return (
                <motion.div
                  key={post.n}
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.2 }}
                  className="group p-5 rounded-2xl bg-white/5 border border-white/10 hover:border-white/20 hover:bg-white/[0.07] transition-all cursor-default"
                  data-testid={`post-${post.n}`}
                >
                  <div className="flex items-start gap-3 mb-3">
                    <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${color}20` }}>
                      <span className="text-sm font-black" style={{ color }}>{post.n}</span>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-sm font-bold leading-snug">{post.title}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <Icon className="w-3.5 h-3.5 flex-shrink-0" style={{ color }} />
                    <span className="text-xs font-medium" style={{ color }}>{post.sub}</span>
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>
        </div>

        {/* Footer info */}
        <div className="text-center mt-12 py-8 border-t border-white/10">
          <p className="text-[#9CA3AF] text-sm">Piano editoriale generato per <strong className="text-[#D4AF37]">schedabusiness.com</strong> — 48 post / 12 mesi</p>
          <div className="flex items-center justify-center gap-4 mt-4">
            <a href="/" className="text-[#4285F4] text-sm font-bold hover:underline flex items-center gap-1">Home <ArrowRight className="w-3 h-3" /></a>
            <a href="/brief-ads" className="text-[#D4AF37] text-sm font-bold hover:underline flex items-center gap-1">Brief Ads <ArrowRight className="w-3 h-3" /></a>
          </div>
        </div>
      </main>
    </div>
  );
}
